import { useState } from 'react';
import { Icon } from '@/design-system/icon/Icon';
import { Btn } from '@/design-system/primitives/Btn/Btn';
import { ACCENT_PRESETS, type Density, type TimelineStyle, useTweaks } from '@/lib/tweaks';
import styles from './TweaksPanel.module.css';

const DENSITY_OPTIONS: { value: Density; label: string }[] = [
  { value: 'compact', label: 'Compact' },
  { value: 'default', label: 'Standaard' },
  { value: 'comfy', label: 'Ruim' },
];

const TIMELINE_OPTIONS: { value: TimelineStyle; label: string }[] = [
  { value: 'milestones', label: 'Mijlpalen' },
  { value: 'gantt', label: 'Gantt' },
];

export function TweaksPanel() {
  const [open, setOpen] = useState(false);
  const accentId = useTweaks((s) => s.accentId);
  const density = useTweaks((s) => s.density);
  const timelineStyle = useTweaks((s) => s.timelineStyle);
  const setAccent = useTweaks((s) => s.setAccent);
  const setDensity = useTweaks((s) => s.setDensity);
  const setTimelineStyle = useTweaks((s) => s.setTimelineStyle);

  if (!open) {
    return (
      <button
        type="button"
        className={styles.fab}
        onClick={() => setOpen(true)}
        aria-label="Open tweaks"
      >
        <Icon name="settings" size={18} />
      </button>
    );
  }

  return (
    <aside className={styles.panel} aria-label="Tweaks">
      <header className={styles.header}>
        <strong>Tweaks</strong>
        <Btn variant="ghost" onClick={() => setOpen(false)} aria-label="Sluiten">
          ✕
        </Btn>
      </header>

      <section className={styles.section}>
        <div className={styles.label}>Accent</div>
        <div className={styles.chips}>
          {ACCENT_PRESETS.map((preset) => (
            <button
              key={preset.id}
              type="button"
              className={`${styles.chip} ${accentId === preset.id ? styles.chipActive : ''}`}
              onClick={() => setAccent(preset.id)}
              aria-pressed={accentId === preset.id}
              aria-label={preset.label}
              style={{ background: preset.accent }}
              title={preset.label}
            />
          ))}
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.label}>Dichtheid</div>
        <div className={styles.segmented} role="radiogroup" aria-label="Dichtheid">
          {DENSITY_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={density === opt.value}
              className={`${styles.segment} ${density === opt.value ? styles.segmentActive : ''}`}
              onClick={() => setDensity(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.label}>Tijdlijn</div>
        <div className={styles.segmented} role="radiogroup" aria-label="Tijdlijn-stijl">
          {TIMELINE_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={timelineStyle === opt.value}
              className={`${styles.segment} ${timelineStyle === opt.value ? styles.segmentActive : ''}`}
              onClick={() => setTimelineStyle(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </section>
    </aside>
  );
}
